import * as React from "react";
import { Button } from "semantic-ui-react";

import { ActionableTaskButtonProps } from "./ActionableTaskButtons";

export const ManagerFeedbackOnReportButton: React.FunctionComponent<ActionableTaskButtonProps> = (props: ActionableTaskButtonProps) => {
    if (props.task.completed) {
        return null;
    }

    return (
        <a href={`/actions/${props.task.caseId}/manager-feedback-on-report/${props.task.id}`} target="_blank" rel="noopener noreferrer">
            <Button
                primary
                content="Complete"
            />
        </a>
    );
};
